var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search" },
    [
      _c(
        "div",
        { staticClass: "search__filters" },
        [
          _c("z-input", {
            staticClass: "search__input",
            attrs: { name: "search", placeholder: _vm.text.placeholder },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.search.apply(null, arguments)
              },
            },
            model: {
              value: _vm.params.q,
              callback: function ($$v) {
                _vm.$set(_vm.params, "q", $$v)
              },
              expression: "params.q",
            },
          }),
          _vm._v(" "),
          _c(
            "z-button",
            { staticClass: "search__button", on: { click: _vm.search } },
            [_vm._v(_vm._s(_vm.text.button))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.searchedData.length
        ? _c("z-caption", { attrs: { tag: "h2", size: "l" } }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.text.title) +
                " " +
                _vm._s(_vm.nav.count) +
                "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12 u-align-items--center" },
          [_vm.loading ? _c("z-preloader") : _vm._e()],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "search__list" },
        _vm._l(_vm.searchedData, function (searchItem, index) {
          return _c("search-card", {
            key: index,
            attrs: { searchItem: searchItem },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("z-pagination", {
        attrs: {
          "show-next": "",
          "show-prev": "",
          data: {
            currentPage: _vm.nav.current,
            totalItems: _vm.nav.count,
            totalPages: _vm.nav.total,
            pageRange: 1,
          },
        },
        on: { change: _vm.loadAnotherPage },
      }),
      _vm._v(" "),
      _vm.wasSearched && !_vm.searchedData.length && !_vm.loading
        ? _c("z-not-found", {
            attrs: {
              text: {
                title: this.params.q.length
                  ? this.text.notFound.title
                  : this.text.emptySearch.title,
                description: this.params.q.length
                  ? ""
                  : this.text.emptySearch.text,
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }